import React, { Component, useState } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, TouchableHighlight, FlatList, ActivityIndicator} from "react-native-web";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

export default function MenuModalMobile(props) {

    const handleClick = () => {

    }


    const onMenuItemPressed = (key) => {
        if (key === 'Account_settings')
        {
           window.location = '/myaccount';
        }
        else if (key === 'Saveds')
        {
           window.location = '/saveditems';
        }
        else if (key === 'Courses')
        {
           window.location = '/mycourses';
        }
        else if (key === 'Payments')
        {
           window.location = '/payments';
        }
        else if (key === 'Signin')
        {
           window.location = '/signin';
        }
        else if (key === 'Signup')
        {
           window.location = '/signup';
        }
        else if (key === 'Signout')
        {
              localStorage.removeItem('jwtToken');
              localStorage.removeItem('yeqolaUser');
              localStorage.removeItem('yeqolaAfter');

              setTimeout(() => {
                 window.location = "/";
              },100);
        }
    }

    const setLocale = (lang) => {



           localStorage.setItem("language", lang);
           i18n.changeLanguage(lang);


    }


    const renderFooterComponent = () => {
     return (
       <div style={{marginTop: '40px'}}>
           <div style={{lineHeight: '55px', color: '#333', fontFamily: 'Roboto', fontSize: '18px'}}>
             {i18n.language == 'fr' &&
                <div style={{textAlign: 'center'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#5800d9'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#5800d9'}}>FR</a></div>
             }
             {i18n.language == 'en' &&
                <div style={{textAlign: 'center'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#5800d9'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#5800d9'}}>FR</a></div>
             }
           </div>
       </div>
     )
    }

    let dataVisitor;

    if (!props.isSignedin)
    {
        dataVisitor = [
          {key: 'Signin', title: i18n.t('signin'), icon: '/img/settings_icon.png'},
          {key: 'Signup', title: i18n.t('signup'), icon: '/img/settings_icon.png'}
        ];
    }
    else
    {
        dataVisitor = [
          {key: 'Account_settings', title: i18n.t('Account_settings'), icon: '/img/settings_icon.png'},
          {key: 'Saveds', title: i18n.t('Mysaveds'), icon: '/img/saved_icon.png'},
          {key: 'Courses', title: i18n.t('Mycourses'), icon: '/img/course_icon.png'},
          {key: 'Payments', title: i18n.t('Payments'), icon: '/img/payment_icon.png'},
          {key: 'Signout', title: i18n.t('Signout'), icon: '/img/signout_icon.png'},
        ];
    }



    return (

          <div id="myNav"
									style={{display: 'none', position: 'absolute', top: '70px', zIndex: 99,
                     width: viewportWidth+'px', height:  viewportHeight+'px',
                         background: '#fff', textAlign: 'center'}}>


                         <FlatList data={dataVisitor}
                              showsHorizontalScrollIndicator={false}
                              ListFooterComponent={renderFooterComponent}
                              renderItem={({ item,index }) =>  (
                                <TouchableHighlight underlayColor="transparent" onPress={() => {onMenuItemPressed(item.key)}}>
                                  <View style={{flexDirection: 'row', height: 60,}}>

                                     <View style={{width: 36, height: 60, marginLeft: 5}}>

                                         <View style={{width: 36, height: 60, justifyContent: 'center'}}>
                                           {item.key === 'Payments' &&
                                             <Image source={{uri: item.icon}} style={{width: 32, height: 32, marginLeft: 5}}/>
                                           }
                                           {item.key === 'Courses' &&
                                             <Image source={{uri: item.icon}} style={{width: 38, height: 38, marginLeft: 0}}/>
                                           }
                                           {item.key !== 'Payments' && item.key !== 'Courses' &&
                                              <Image source={{uri: item.icon}} style={{width: 36, height: 36, marginLeft: 0}}/>
                                            }
                                         </View>

                                     </View>
                                     <View style={{width: viewportWidth-51, height: 60, marginLeft: 15, justifyContent: 'center', borderTop: index === 0 ? 'none':'1px solid #ddd', borderBottom: index ===  dataVisitor.length-1 ? '1px solid #ddd':'none'}}>
                                        <Text style={{color: (item.key !== 'Signin' &&  item.key !== 'Signup') ? '#111':'#5800d9', fontSize: 17, textAlign: 'left'}}>{item.title}</Text>
                                     </View>
                                  </View>
                                </TouchableHighlight>
                              )}
                              keyExtractor={(item, index) => ''+index}
                              />



           </div>

    )

}
